<template>
  <div style="text-align: center; margin-top: 200px">
    <h2>请输入密码进入</h2>
    <input
      v-model="pwd"
      type="password"
      @keyup.enter="login"
      style="padding: 10px; font-size: 18px"
    />
    <button @click="login" style="padding: 10px 20px; margin-left: 10px">
      确定
    </button>
    <p style="color: red; margin-top: 20px">{{ msg }}</p>
  </div>
</template>
  
  <script>
export default {
  data() {
    return {
      pwd: "",
      msg: "",
    };
  },
  methods: {
    login() {
      // this.axios.post('/api/gate/verify', { password: this.pwd })
      //   .then(res => {
      //     if (res.data.code === 200) {
      //         sessionStorage.setItem('gate_ok', '1')
      //       this.$router.push('/')               // 或者跳转到之前想去的页面
      //     } else {
      //       this.msg = '密码错误'
      //     }
      //   })
      this.$axios({
        method: "post",
        url: "/api/gate/verify", // 改成你的实际接口
        params: {
          pwd: this.pwd,
        },
      }).then((resp) => {
        if (resp.data.code === 200) {
          sessionStorage.setItem("gate_ok", "1");
          this.$router.push("/linkManage");
        } else {
          this.msg = "密码错误";
        }
      });
    },
  },
  created() {
    // 如果已经验证过，直接跳走
    if (sessionStorage.getItem("gate_ok") === "1") {
      this.$router.push("/linkManage");
    }
  },
};
</script>